import { useCallback } from "react";
import { ExtendedProjectInfoDc } from "@evergis/api";

import { useBasemapSelectModule } from "../appConfig/useAppModule";
import { project } from "../../resources/projects";
import { useSharedProject, useSharedProjectBaseMap } from "./useSharedProject";

export const useBaseMapShared = () => {
  const { options } = useBasemapSelectModule();
  const sharedProject = useSharedProject();
  const baseMapName = useSharedProjectBaseMap();

  const updateMap = useCallback(
    (mapName: string) => {
      if (sharedProject.name) {
        project.write({
          input: sharedProject.name,
          reducer: mapLayer => ({
            ...mapLayer,
            content: { ...(mapLayer as ExtendedProjectInfoDc).content, baseMapName: mapName },
          }),
        });
      }
    },
    [sharedProject.name],
  );

  return {
    data: options ? options.items : [],
    baseMapName,
    updateMap,
  };
};
